<template>
  <div class="parameter-manage">
    <div class="parameter-manage-main">
      <div class="left">
        <div class="parameter-group">
          <div
            v-for="(item, index) in ruleNameList"
            :key="item.id"
            :class="
              activeIndex === index
                ? 'active parameter-group-row'
                : 'parameter-group-row'
            "
            @click="selecd(index, item.id)"
          >
            <span class="parameter-group-row-content">
              {{ `${item.ruleName}(${item.nums})` }}
              <el-dropdown
                v-if="index != 0"
                trigger="click"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  <img src="../../../../assets/tree/three-spot.png">
                </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command="beforeHandleCommand(item, 'rename', index)" class="rename">重命名</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item, 'delete', index)" class="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </div>
          <el-input
            v-if="inputVisible"
            class="white input-new-parameterGroupName"
            v-model="inputValue"
            placeholder="请输入规制名"
            @keyup.enter.native="addInputConfirm"
            @blur="addInputConfirm"
          >
          </el-input>
        </div>
        <div v-if="ruleNameList.length < 2">
          <div class="nothing-add">
            <div>
              <div>
                <img src="../../../../assets/nothing-add.png" />
              </div>
              <p>请先增分类</p>
            </div>
          </div>
        </div>
        <div class="add-parameter-group">
          <el-button class="btn-blue" @click="addRuleName">新增分类</el-button>
        </div>
      </div>
      <div class="right">
        <div class="parameter-search">
          <div class="add-parameter-manage">
            <el-button v-if="ruleId>0" class="btn-blue" @click="addParameter">新增规制</el-button>
          </div>
          <el-input
            class="white w320"
            placeholder="请输入规制名"
            @keyup.enter.native="searchRightRuleName"
            v-model="ruleNameRightSearch"
          >
            <i slot="suffix" class="el-input__icon el-icon-search"  @click="searchRightRuleName"></i>
          </el-input>
        </div>
        <div class="table" ref="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="ruleName"
              label="规制名"
            ></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <i class="el-icon-edit" @click="modRule(scope.row)"></i>
                <i class="el-icon-delete" @click="delRule(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" ref="form">
        <el-form-item
          label="规制分类名"
          prop="tmpName"
        >
          <el-input
            class="gray white"
            v-model="form.ruleTypeName"
            placeholder="请输入规制分类名"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
    >
      <div class="drawer-title">
        <i class="el-icon-close" @click="closeDrawer"></i>
        <div>
          <el-button type="text" class="btn-gray" @click="closeDrawer"
            >取消</el-button
          >
          <el-button
            type="text"
            class="btn-blue"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
        </div>
      </div>
      <div class="sub-title">{{ subTitle }}</div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="规制名" prop="name">
          <el-input
            class="gray white"
            v-model="ruleForm.name" 
            type="textarea"
            placeholder="请输入详细内容"
            :autosize="{ minRows: 5, maxRows: 5 }"
            resize="none"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="规制分类" prop="ruleType">
          <el-select
            v-model="ruleForm.ruleType"
            class="gray white"
            clearable
          >
            <el-option
              v-for="(item, index) in ruleTypeList"
              :key="index"
              :label="item.ruleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script >
import PaginationTpl from "@/components/PaginationTpl.vue";
import { config } from "@/common/js/config.js";
import Authoritative from "@/models/authoritative.js";
export default {
  data() {
    return {
      ruleId: 0,
      ruleNameList: [],
      activeIndex: 0,
      activeIndexCopy: 0,
      inputVisible: false,
      inputValue: '',
      dialogTitle: "重命名",
      dialogVisible: false,
      form: {
        ruleTypeId: '',
        ruleTypeName: "",
      },
      drawer: false,
      subTitle: '编辑',
      ruleTypeList: [],
      ruleForm: {
        id: '',
        name: '',
        ruleType: ''
      },
      /* ------------------ 以下是右边的字段 ------------ */
      ruleNameRightSearch: '',
      tableData: [],
      timerId: null
    };
  },
  components: {
    PaginationTpl,
  },
  created() {
    config();
    this.initRuleNameList()
    this.initTableRuleNameList()
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },
  methods: {
    initRuleNameList() {
      Authoritative.getRuleTypeList().then(res => {
        if (res.success) {
          let arr = []
          let arr2 = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.ruleName = i.name
            obj.nums = i.titleNum
            obj.isModifyRuleName = true
            arr.push(obj)
            arr2.push(obj)
          })
          this.ruleNameList = arr
          this.ruleTypeList = arr2
          this.ruleTypeList.shift()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /*------------------------------- 以下是左边的方法 --------------------------------*/
    /* 规制名点击高亮 */
    selecd(index, id) {
      this.activeIndex = index
      this.ruleNameList.map((i,idx) =>　{
        if (index != idx) {
          i.isModifyRuleName = true
        }
      })
      this.ruleId = id
      this.initTableRuleNameList()
    },
    /* 新增规制名 */
    addRuleName() {
      this.inputVisible = true;
      this.activeIndexCopy = this.activeIndex
      this.activeIndex = null
    },
    addInputConfirm() {
      if (this.inputValue) {
        this.addRuleType()
      } else {
        this.activeIndex = this.activeIndexCopy
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    addRuleType() {
      let name = this.inputValue
      let data = {
        name
      }
      Authoritative.postAddRuleType(data).then(res => {
        if (res.success) {
          this.initRuleNameList()
          this.timerId = setTimeout(() => {
            let length = this.ruleNameList.length - 1
            this.activeIndex = length
            this.ruleId = this.ruleNameList[length].id
            this.initTableRuleNameList()
          },600)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command,index){
      return {
        'value': value,
        'command':command,
        'index': index
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "rename":
          this.form.ruleTypeId = command.value.id
          this.form.ruleTypeName = command.value.ruleName
          this.dialogVisible = true;
          break;
        case "delete":
          if (command.value.nums > 0) {
            this.$alert('请先删除所有子规制再进行删除分类操作', '确认删除分类', {
              confirmButtonText: '好的',
              confirmButtonClass: 'btn-gray'
            })
          } else {
            this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
              confirmButtonText: "删除",
              cancelButtonText: "取消",
              confirmButtonClass: 'btn-red',
              cancelButtonClass: 'btn-gray'
            }).then(() => {
              this.delRuleType(command.value.id)
            });
          }
          break;
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },

    clear() {
      this.form.ruleTypeName = "";
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.rename()
          this.clear();
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    rename() {
      let id = this.form.ruleTypeId
      let name = this.form.ruleTypeName
      let data = {
        id,
        name
      }
      Authoritative.postRename(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "重命名成功",
          });
          this.initRuleNameList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    delRuleType(id) {
      let data = {
        id
      }
      Authoritative.postDelRuleType(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.initRuleNameList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* ------------------------------ 以下是右边的方法 ------------------------------ */
    initTableRuleNameList() {
      let categoryId = this.ruleId
      let titleName = this.ruleNameRightSearch
      let data = {
        categoryId,
        titleName
      }
      Authoritative.getRuleList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.categoryId = i.categoryId
            obj.ruleName = i.name
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 搜索 */
    searchRightRuleName() {
      this.initTableRuleNameList()
    },
    delRule(row) {
      let data = {
        id: row.id
      }
      Authoritative.postDelRule(data).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.initRuleNameList()
          this.initTableRuleNameList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 新增规制 */
    addParameter() {
      this.$router.push({
        path: '/fire/authoritativeModuleIndex/archivesIndex/add-regulatory',
        query: {
          categoryId: this.ruleId
        }
      })
    },
    modRule(row) {
      this.ruleForm.id = row.id
      this.ruleForm.name = row.ruleName
      this.ruleForm.ruleType = row.categoryId
      this.drawer = true
    },
    closeDrawer() {
      this.ruleForm.id = ''
      this.ruleForm.name = ''
      this.ruleForm.ruleType = ''
      this.drawer = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.ruleForm.id
          let titleName = this.ruleForm.name
          let targetCategoryId = this.ruleForm.ruleType
          let data = {
            id,
            titleName,
            targetCategoryId
          }
          Authoritative.postModRule(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '编辑成功'
              })
              this.initRuleNameList()
              this.initTableRuleNameList()
              this.closeDrawer()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.parameter-manage {
  flex: 1;
  background: $bg-white;
  padding: 20px;
  box-sizing: border-box;
  .parameter-manage-main {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    border: 1px solid $bg-DoopLightSnow;
    border-radius: 4px;
    .left {
      width: 240px;
      // height: 794px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
      overflow-y: scroll;
      position: relative;
      .parameter-group {
        flex: 1;
        padding-top: 6px;
        .parameter-group-row {
          height: 36px;
          line-height: 36px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: #666666;
          padding: 0px 16px;
          cursor: pointer;
          .parameter-group-row-content {
            @include flex-between;
          }
        }
        .active {
          color:$color-DeepReddishBlue;
          background: #f5f8fe;
        }
      }
      .add-parameter-group {
        margin: 16px;
        .el-button {
          width: 100%;
        }
      }
      .nothing-add {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        img {
          width: 104px;
          height: 87px;
        }
        p {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-LightGrey;
          margin-top: 20px;
        }
      }
    }
    .right {
      flex: 1;
      padding: 17px;
      border-left: 1px solid $bg-DoopLightSnow;
    }
    .add-parameter-manage {
      .el-button {
        width: 128px;
      }
    }
    .parameter-search {
      height: 64px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      padding-left: 16px;
      @include flex-between;
      .w320 {
        width: 320px;
        margin-right: 16px;
      }
    }
    .el-icon-edit {
      margin-right: 20px;
    }
  }
  .parameter-tag {
    display: inline-block;
  }
  .tag-name {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sub-title {
    text-align: left;
    font-size: $fs-medium-s;
    font-weight: 400;
    margin-bottom: 25px;
    color: $color-Step;
  }
  .el-drawer__wrapper {
    top: 119px !important;
  }
}
</style>
<style lang="scss">
.parameter-manage {
  .input-new-parameterGroupName {
    border-radius: 0px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: 0px;
      top: 6px;
      width: 4px;
      height: 24px;
      background: $color-DeepReddishBlue;
    }
    .el-input__inner {
      height: 36px;
      border: none;
      color: $color-DeepReddishBlue;
      background: #f5f8fe;
    }
  }
  .parameter-manage-main {
    .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: auto;
    }
    .right {
      .parameter-search {
        .el-input__prefix, .el-input__suffix {
          top: 3px;
        }
      }
    }
  }
  .el-dropdown-link {
    @include extend-click;
  }
}
.delete {
  color: $color-Crimson!important;
  font-size: $fs-small-l;
}
</style>